'use client'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import HeaderField from './fields/header-field'

export default function HeaderForm({ form, formStep, nextButtonClick }) {
  const headerImgValue = form.watch('headerImg')

  return (
    <div
      className={cn('flex h-full w-full flex-col justify-center gap-5 pb-6', {
        hidden: formStep !== 2,
      })}
    >
      <div className="flex h-full grow flex-col justify-between gap-6">
        <HeaderField form={form} />
        <div className="flex justify-start gap-2">
          <Button variant="outline" type="button" onClick={nextButtonClick}>
            Do it later
          </Button>
          <Button
            type="button"
            disabled={!headerImgValue}
            onClick={nextButtonClick}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}
